const { fieldLabels } = require('../field-labels');

const specialFieldLabelOverrides = {
  visual: {
    measurements: 'Visual Findings',
  },
};

export function getFieldLabelName(entity, fieldKey) {
  const type = entity.localEntity?.type;

  if (specialFieldLabelOverrides[type]?.[fieldKey]) {
    return specialFieldLabelOverrides[type][fieldKey];
  }

  return fieldLabels[fieldKey] || fieldKey;
}

export function getConflictText(entity) {
  let conflictText = entity.conflictDetails?.conflictLabel || '';

  if (entity.type === 'rat') {
    conflictText = 'RAT bubble';
  }

  if (entity.number) {
    conflictText = `Bubble ${entity.number} ${conflictText}`;
  }

  if (entity.type === 'tablequestion') {
    return 'Table Question conflict';
  }

  return conflictText;
}
